import { render, staticRenderFns } from "./TrSelectGameWithText.vue?vue&type=template&id=1fe100b7&scoped=true&"
import script from "./TrSelectGameWithText.vue?vue&type=script&lang=js&"
export * from "./TrSelectGameWithText.vue?vue&type=script&lang=js&"
import style0 from "./TrSelectGameWithText.vue?vue&type=style&index=0&id=1fe100b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe100b7",
  null
  
)

export default component.exports